import { jsxs, jsx } from 'react/jsx-runtime';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import classes from './SplashLogo.module.scss.js';
import img$1 from '../../assets/images/logo/logo_white.svg.js';
import img from '../../assets/images/logo/logo_black.svg.js';

const SplashLogo = ({ className = "", useLogoBlack = true, }) => {
    const { t } = useTranslation("monorepo-noku-library");
    return (jsxs("div", { className: cx(classes.splashLogo, className), children: [jsx("img", { alt: "logo", src: useLogoBlack ? img : img$1 }), jsx("span", { className: cx(classes.logoSubtitle, { [classes.logoBlack]: useLogoBlack }), children: t("welcomeToNokuWorld") })] }));
};

export { SplashLogo as default };
